import React, { useState, useEffect, useRef, useMemo } from 'react';

import { translatedMessage } from '../../service/LanguageService';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import DataTableUtils from '../../utilities/DataTableUtils';
import { CompetitionService } from '../../service/CompetitionService';

const CompetitionLanguageListViewComponent = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [languageList, setLanguageList] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setIsLoading(true)

        const getLanguages = async () => {
            await competitionService.getCompetitionLanguageList(props?.competition?.id)
                .then((response) => {
                    let _lList = response.filter(item => item.minorityLanguage === props?.minorityLanguages)
                    setLanguageList(_lList);
                    setIsLoading(false);
                })
                .catch((error) => error && toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getLanguages()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, competitionService]);

    if (isLoading) {
        return (
            <div className='w-full flex align-items-center'>
                <Toast ref={toast}></Toast>
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className='col-12 mt-5'>
                    <h5 className='mb-1'>{translatedMessage(props?.minorityLanguages ? 'competition.requirements.language.minority' : 'competition.requirements.language')}</h5>
                    <DataTable
                        ref={dt}
                        value={languageList}
                        dataKey="id"
                        // paginator
                        rows={DataTableUtils.defalRowsPerPage()}
                        rowsPerPageOptions={DataTableUtils.rowsPerPageOptions()}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate={"{first} - {last} " + translatedMessage('generic.of') + " {totalRecords}"}
                        emptyMessage={translatedMessage("generic.tableEmptyMessage")}
                        responsiveLayout="scroll"
                    >
                        <Column
                            field="language"
                            header={translatedMessage("generic.nameRo")}
                            headerStyle={{ width: '15%', minWidth: '8rem' }}
                            body={(e) => e.minorityLanguage ? e.languageName : e.language.label}
                        />
                        <Column
                            field="level"
                            header={translatedMessage("competition.requirements.language.level")}
                            headerStyle={{ width: '10%', minWidth: '8rem' }}
                            body={(e) => translatedMessage("LanguageLevel."+e.level)}
                        />
                        <Column
                            field="proofingMethod"
                            header={translatedMessage("competition.requirements.language.proofing")}
                            headerStyle={{ width: '65%', minWidth: '8rem' }}
                        />
                    </DataTable>
                </div>
            </>
        );
    }
};

export default CompetitionLanguageListViewComponent;
